<template>
  <div>
    <cursoHeader></cursoHeader>
    <div class="bg-white border border-gray my2 px2">
      <ul>
        <li
          class="h3"
          v-for="record in $dados.ASSUNTOS.records"
          :key="record.ID"
        >
          {{record.NOME}}
        </li>
      </ul>
    </div>
    <menuBotoes></menuBotoes>
  </div>
</template>

<script>
import cursoHeader from '@/custom/cursoHeader'
import menuBotoes from '@/custom/menuBotoes'
var componentData = {
  response: {},
  record: {}
}
var componentDefinition = {
  components: { cursoHeader, menuBotoes },
  route: {
    name: 'ASSUNTOS',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/assuntos',
    meta: {
      title: 'Assuntos',
      hidden: true
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return componentData
  },
  methods: {
    goto: function (name) {
      this.$router.push({
        name: name,
        params: this.$route.params
      })
    }
  }
}
export default componentDefinition
</script>
